import { Stack } from '@mui/material'
import type { FC } from 'react'
import {
  dayFormatLabel,
  dayFormats,
  hourFormatLabel,
  hourFormats,
  monthFormatLabel,
  monthFormats,
  yearFormatLabel,
  yearFormats,
} from './dateFormats'
import { DurationField } from './DurationField'
import { NotationOrder } from './NotationOrder'

const durationFields = [
  {
    durationName: 'expirationDuration.years' as const,
    formatName: 'expirationYear' as const,
    label: '+年',
    min: 0,
    max: 1000,
    formats: yearFormats,
    formatLabels: yearFormatLabel,
  },
  {
    durationName: 'expirationDuration.months' as const,
    formatName: 'expirationMonth' as const,
    label: '+月',
    min: 0,
    max: 1000,
    formats: monthFormats,
    formatLabels: monthFormatLabel,
  },
  {
    durationName: 'expirationDuration.days' as const,
    formatName: 'expirationDay' as const,
    label: '±日',
    min: -31,
    max: 1000,
    formats: dayFormats,
    formatLabels: dayFormatLabel,
  },
  {
    durationName: 'expirationDuration.hours' as const,
    formatName: 'expirationHour' as const,
    label: '+時',
    min: 0,
    max: 1000,
    formats: hourFormats,
    formatLabels: hourFormatLabel,
  },
] as const

export const ExpirationFieldGroup: FC = () => {
  return (
    <Stack spacing={1}>
      {durationFields.map(config => (
        <DurationField key={config.durationName} config={config} />
      ))}
      <NotationOrder />
    </Stack>
  )
}
